function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { sdkLogger } from '../../logger';
import { calculateStreamPositionFromDate } from './event-utils';
import { CvsdkEventCueType } from './event.enums';
var _obj, _obj1;
/**
 * Helper map that determines firing priority of event types when they have overlapping timestamps.
 * Start events always take precedence over exit events.
 */ var EVENT_CUE_TYPE_PRIORITY_MAP = {
    start: (_obj = {}, _define_property(_obj, CvsdkEventCueType.AdBreak, 4), _define_property(_obj, CvsdkEventCueType.Ad, 5), _define_property(_obj, CvsdkEventCueType.AdTracking, 6), // Ad events take precedence
    _define_property(_obj, CvsdkEventCueType.Custom, 8), _obj),
    end: (_obj1 = {}, _define_property(_obj1, CvsdkEventCueType.AdBreak, 3), _define_property(_obj1, CvsdkEventCueType.Ad, 2), _define_property(_obj1, CvsdkEventCueType.AdTracking, 1), // Ad events take precedence
    _define_property(_obj1, CvsdkEventCueType.Custom, 7), _obj1)
};
/** Helper map to determine if a cue's timestamps are already based on stream time as opposed to the content time */ var STREAM_TIME_CUE_TYPE_MAP = new Set([
    CvsdkEventCueType.AdBreak,
    CvsdkEventCueType.Ad,
    CvsdkEventCueType.AdTracking
]);
/* Reset firedLast values for the start/end events on the current cue id, then set firedLast on the current trigger */ var setFiredLast = function(cueTriggers, trigger) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cueTriggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var target = _step.value;
            if (target.cue.id === trigger.cue.id) {
                target.firedLast = false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    trigger.firedLast = true;
};
var AD_EVENT_CUE_TYPES = [
    CvsdkEventCueType.AdBreak,
    CvsdkEventCueType.Ad,
    CvsdkEventCueType.AdTracking
];
/**
 * Responsible for storing the cues and the callbacks, When registering points
 * with the EventTrack, is responsible for passing the right callbacks to the
 * EventTrack. The EventTrack is only responsible for invoking the callback at the
 * correct time
 */ export var EventManager = /*#__PURE__*/ function() {
    "use strict";
    function EventManager(eventTrack, onPlaybackTimelineUpdated, advertsManager) {
        var _this = this;
        var _this1 = this;
        _class_call_check(this, EventManager);
        _define_property(this, "eventTrack", void 0);
        _define_property(this, "advertsManager", void 0);
        _define_property(this, "cueStartCallbacks", void 0);
        _define_property(this, "cueEndCallbacks", void 0);
        _define_property(this, "cueUpdatedCallbacks", void 0);
        _define_property(this, "cueRegisteredCallbacks", void 0);
        // Note: We pass a normal EventCue as it's possible for the RegisteredEventCue properties to not be available right away
        _define_property(this, "cueUnregisteredCallbacks", void 0);
        _define_property(this, "cueTriggers", void 0);
        // From a cue we will have a start trigger and an end trigger in this array
        _define_property(this, "cuesPendingDateTranslation", void 0);
        // If clients provide a date in the startTime or endTime, we store it here until we have a seekableRange we can use to translate it back into positions
        _define_property(this, "cueIdsPendingUnregistration", void 0);
        // For non-persistent cues we need to unregister them, but will be deferred to the next second, as the eventTrack could still be iterating them;
        _define_property(this, "currentIdIncrement", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "completedCueIds", void 0);
        /**
     * This callback is passed to the event track and triggered whenever an eligible cue start or cue end time is reached.
     * This method itself is responsible for determining which events should fire and invoking them. Since we have an
     * array of all the startTime, endTimes and types in the `this.cueTriggers` array, we can filter this down to the time
     * and sort them in priority order.
     * @param streamTime
     * @returns
     */ _define_property(this, "getAndFireEligibleCallbacks", void 0);
        this.eventTrack = eventTrack;
        this.advertsManager = advertsManager;
        this.cueStartCallbacks = new Map();
        this.cueEndCallbacks = new Map();
        this.cueUpdatedCallbacks = new Map();
        this.cueRegisteredCallbacks = new Map();
        this.cueUnregisteredCallbacks = new Map();
        this.cueTriggers = [];
        this.cuesPendingDateTranslation = new Map();
        this.cueIdsPendingUnregistration = new Set();
        this.currentIdIncrement = 1;
        this.logger = sdkLogger.withContext('EventManager');
        this.completedCueIds = new Set();
        this.getAndFireEligibleCallbacks = function(streamTime) {
            var backwardSeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var eligibleCueTriggers = _this1.cueTriggers.filter(function(trigger) {
                if (backwardSeek) {
                    // For backward seeks, we should only fire exit events since the streamTime will equal the startTime of the cue instead of the endTime
                    return streamTime === trigger.cue.startTime && trigger.eventToFire === 'end';
                } else if (trigger.timeToFire === streamTime && !trigger.triggerCompleted) {
                    if (trigger.eventToFire === 'end') {
                        var startCue = _this1.cueTriggers.find(function(cueTrigger) {
                            return cueTrigger.cue.id === trigger.cue.id && cueTrigger.eventToFire === 'start';
                        });
                        // Check if the cue's start event fired last out of the start/end pair. If not, don't fire the end event
                        return !(startCue && startCue.firedLast === false);
                    } else {
                        return !trigger.firedLast;
                    }
                } else {
                    return false;
                }
            });
            var cueTriggersInPriorityOrder = eligibleCueTriggers.sort(function(a, b) {
                var prA = _this1.calculatePriority(a.cue.type, a.eventToFire);
                var prB = _this1.calculatePriority(b.cue.type, b.eventToFire);
                return prA - prB;
            });
            var target = _this1.getNextEventTrigger(cueTriggersInPriorityOrder);
            if (target) {
                if (eligibleCueTriggers[eligibleCueTriggers.length - 1] === target) {
                    // Reset all triggers (since we don't expect any more to occur)
                    _this1.cueTriggers.forEach(function(trigger) {
                        if (backwardSeek) {
                            if (streamTime === trigger.cue.startTime && trigger.eventToFire === 'end') {
                                trigger.triggerCompleted = false;
                            }
                        } else if (trigger.timeToFire === streamTime) {
                            trigger.triggerCompleted = false;
                        }
                    });
                } else {
                    // Mark this trigger as fired so it's not triggered again
                    target.triggerCompleted = true;
                }
                setFiredLast(_this1.cueTriggers, target);
                var callbacks = target.eventToFire === 'start' && !backwardSeek ? _this1.cueStartCallbacks.get(target.cue.type) : _this1.cueEndCallbacks.get(target.cue.type);
                if (!callbacks) return;
                target.cue.isRepeatEvent = _this1.completedCueIds.has(target.cue.id);
                callbacks.forEach(function(callback) {
                    return callback(target.cue);
                });
                if (target.eventToFire === 'end' || backwardSeek) {
                    _this1.completedCueIds.add(target.cue.id);
                    if (!target.cue.isPersistent) {
                        _this1.cueIdsPendingUnregistration.add(target.cue.id);
                    }
                }
            }
        };
        onPlaybackTimelineUpdated(function(playbackTimeline) {
            _this.unregisterCuesFallenOutOfLiveWindow(playbackTimeline);
            _this.unregisterNonPersistentCues();
            if (_this.cuesPendingDateTranslation.size > 0) {
                _this.translateDatesToPositionsAndCompleteRegistration(playbackTimeline);
            }
        });
    }
    _create_class(EventManager, [
        {
            key: "toStreamTime",
            value: function toStreamTime(cue, time) {
                if (STREAM_TIME_CUE_TYPE_MAP.has(cue.type)) {
                    return time;
                }
                return this.advertsManager.contentTimeToTimeIncludingAds(time);
            }
        },
        {
            key: "registerEventCue",
            value: function registerEventCue(cue) {
                var cueId = this.internalRegisterEventCue(cue, this.generateCueId(cue));
                var registerCallback = this.cueRegisteredCallbacks.get(cue.type);
                if (registerCallback) {
                    registerCallback.forEach(function(callback) {
                        return callback(cueId, cue);
                    });
                }
                return cueId;
            }
        },
        {
            key: "updateEventCueEndTime",
            value: /**
     * Incase of UnboundedEventCue updateEndTimeForEventCue will provide a way to update cueTriggers and eventTrack
     * @param cueId
     * @param newTime
     * @returns Boolean
     */ function updateEventCueEndTime(cueId, newTime) {
                var cueEndTrigger = this.cueTriggers.find(function(trigger) {
                    return trigger.cue.id === cueId && trigger.eventToFire === 'end';
                });
                if (!cueEndTrigger) return false;
                cueEndTrigger.timeToFire = newTime;
                cueEndTrigger.cue.endTime = newTime;
                var updatedCallback = this.cueUpdatedCallbacks.get(cueEndTrigger.cue.type);
                if (updatedCallback) {
                    updatedCallback.forEach(function(callback) {
                        return callback(cueId, cueEndTrigger.cue);
                    });
                }
                this.eventTrack.updateCueEndTime(cueEndTrigger.cue.id, newTime, this.getAndFireEligibleCallbacks);
                return true;
            }
        },
        {
            key: "internalRegisterEventCue",
            value: /**
     * Private because we shouldn't pass id from outside
     *
     * Register an EventCue, if the EventCue has been provided with Dates for startTime and endTime instead of numbers,
     * it will held temporarily in `cuesPendingDateTranslation` until the seekableRange is available and we can
     * translate the date to a stream position. When the seekableRange is available. We call `translateDatesToPositionsAndCompleteRegistration`
     * which will call this method again, this time passing in its existingId.
     *
     * @param cue
     * @param id passed in when attempting to re-register a cue which formerly had Dates for its times instead of stream positions
     * @returns
     */ function internalRegisterEventCue(cue, id) {
                id !== null && id !== void 0 ? id : id = this.generateCueId(cue);
                this.logger.verbose("attempting to register cue with id of ".concat(id));
                if (_instanceof(cue.startTime, Date) || _instanceof(cue.endTime, Date)) {
                    // queue them until we have the seekableRange available, then we can calculate them and translate them into stream positions
                    // unfortunately we don't know we will have the seekableRange available at this moment in time so we have to queue them and rely on
                    // translateDatesToPositionsAndCompleteRegistration to finish up
                    this.cuesPendingDateTranslation.set(id, cue);
                } else {
                    var _this_cueTriggers;
                    // this cue already has startTime and endTime as a stream position, these are ready to register
                    var registeredEventCue = {
                        id: id,
                        type: cue.type,
                        startTime: this.toStreamTime(cue, cue.startTime),
                        endTime: this.toStreamTime(cue, cue.endTime),
                        data: cue.data,
                        isPersistent: cue.isPersistent
                    };
                    var triggers = this.createEventCueTriggers(registeredEventCue);
                    (_this_cueTriggers = this.cueTriggers).push.apply(_this_cueTriggers, _to_consumable_array(triggers));
                    this.eventTrack.registerCue(id, registeredEventCue, this.getAndFireEligibleCallbacks);
                }
                return id;
            }
        },
        {
            key: "unregisterCuesFallenOutOfLiveWindow",
            value: /** Please note the seekable range is a smaller window nested inside the live window that provides some tolerance */ function unregisterCuesFallenOutOfLiveWindow(param) {
                var _this = this;
                var liveWindow = param.liveWindow;
                if (!liveWindow) return;
                var dvrWindowStart = liveWindow.start;
                var cuesIdsToRemove = [];
                for(var i = 0; i < this.cueTriggers.filter(function(t) {
                    return t.eventToFire === 'end';
                }).length; i++){
                    var trigger = this.cueTriggers[i];
                    // AdEventsManager handles live window fallout for ad cues, so this avoids competing logic
                    if (!AD_EVENT_CUE_TYPES.includes(trigger.cue.type) && trigger.cue.endTime < dvrWindowStart) {
                        this.logger.verbose('Cue "'.concat(trigger.cue.id, '" falls out of the DVR window'));
                        cuesIdsToRemove.push(trigger.cue.id);
                    }
                }
                cuesIdsToRemove.forEach(function(id) {
                    return _this.unregisterEventCue(id);
                });
            }
        },
        {
            key: "unregisterNonPersistentCues",
            value: function unregisterNonPersistentCues() {
                var _this = this;
                if (this.cueIdsPendingUnregistration.size > 0) {
                    this.cueIdsPendingUnregistration.forEach(function(id) {
                        return _this.unregisterEventCue(id);
                    });
                    this.cueIdsPendingUnregistration.clear();
                }
            }
        },
        {
            key: "translateDatesToPositionsAndCompleteRegistration",
            value: function translateDatesToPositionsAndCompleteRegistration(playbackTimeline) {
                var _this = this;
                var _playbackTimeline_seekableRange;
                if (!((_playbackTimeline_seekableRange = playbackTimeline.seekableRange) === null || _playbackTimeline_seekableRange === void 0 ? void 0 : _playbackTimeline_seekableRange.startDate) && !playbackTimeline.absolutePosition) return;
                this.cuesPendingDateTranslation.forEach(function(cue, id) {
                    cue.startTime = calculateStreamPositionFromDate(cue.startTime, playbackTimeline);
                    cue.endTime = calculateStreamPositionFromDate(cue.endTime, playbackTimeline);
                    _this.internalRegisterEventCue(cue, id);
                });
                this.cuesPendingDateTranslation.clear();
            }
        },
        {
            key: "generateCueId",
            value: function generateCueId(cue) {
                return "".concat(cue.type, "-").concat(this.currentIdIncrement++);
            }
        },
        {
            key: "calculatePriority",
            value: function calculatePriority(type, position) {
                if ([
                    CvsdkEventCueType.AdBreak,
                    CvsdkEventCueType.AdTracking,
                    CvsdkEventCueType.Ad
                ].includes(type)) {
                    var eventCueType = type;
                    return EVENT_CUE_TYPE_PRIORITY_MAP[position][eventCueType];
                } else {
                    return EVENT_CUE_TYPE_PRIORITY_MAP[position][CvsdkEventCueType.Custom];
                }
            }
        },
        {
            key: "getNextEventTrigger",
            value: /**
     * Given an array of triggers, works out which trigger is next to be fired.
     * @param cueTriggers an array of triggers, a mixture of start and end events ordered by priority
     * @returns the next cueTrigger to fire
     */ function getNextEventTrigger(cueTriggers) {
                for(var i = 0; i < cueTriggers.length; i++){
                    var targetTrigger = cueTriggers[i];
                    if (!targetTrigger.triggerCompleted) {
                        return targetTrigger;
                    }
                }
                return null;
            }
        },
        {
            key: "unregisterEventCue",
            value: function unregisterEventCue(cueId) {
                var triggerStartIndex = this.cueTriggers.findIndex(function(trigger) {
                    return trigger.cue.id === cueId && trigger.eventToFire === 'start';
                });
                if (triggerStartIndex < 0) return false;
                var targetStartCue = this.cueTriggers[triggerStartIndex];
                this.eventTrack.unregisterCue(targetStartCue.cue.id);
                this.cueTriggers.splice(triggerStartIndex, 1);
                var triggerEndIndex = this.cueTriggers.findIndex(function(trigger) {
                    return trigger.cue.id === cueId && trigger.eventToFire === 'end';
                });
                this.cueTriggers.splice(triggerEndIndex, 1);
                var unregisterCallback = this.cueUnregisteredCallbacks.get(targetStartCue.cue.type);
                if (unregisterCallback) {
                    unregisterCallback.forEach(function(callback) {
                        return callback(targetStartCue.cue);
                    });
                }
                return true;
            }
        },
        {
            key: "onEventCueEntered",
            value: function onEventCueEntered(type, callback) {
                var callbackList = this.cueStartCallbacks.get(type);
                if (!callbackList) {
                    callbackList = [];
                    this.cueStartCallbacks.set(type, callbackList);
                }
                callbackList.push(callback);
            }
        },
        {
            key: "onEventCueExited",
            value: function onEventCueExited(type, callback) {
                var callbackList = this.cueEndCallbacks.get(type);
                if (!callbackList) {
                    callbackList = [];
                    this.cueEndCallbacks.set(type, callbackList);
                }
                callbackList.push(callback);
            }
        },
        {
            key: "onEventCueRegistered",
            value: function onEventCueRegistered(type, callback) {
                var callbackList = this.cueRegisteredCallbacks.get(type);
                if (!callbackList) {
                    callbackList = [];
                    this.cueRegisteredCallbacks.set(type, callbackList);
                }
                callbackList.push(callback);
            }
        },
        {
            key: "onEventCueUpdated",
            value: function onEventCueUpdated(type, callback) {
                var callbackList = this.cueUpdatedCallbacks.get(type);
                if (!callbackList) {
                    callbackList = [];
                    this.cueUpdatedCallbacks.set(type, callbackList);
                }
                callbackList.push(callback);
            }
        },
        {
            key: "onEventCueUnregistered",
            value: function onEventCueUnregistered(type, callback) {
                var callbackList = this.cueUnregisteredCallbacks.get(type);
                if (!callbackList) {
                    callbackList = [];
                    this.cueUnregisteredCallbacks.set(type, callbackList);
                }
                callbackList.push(callback);
            }
        },
        {
            key: "createEventCueTriggers",
            value: /**
     * From a cue and Id, creates two EventCueTriggers, one for the start/onEnterCue and one for the end/onExitCue
     */ function createEventCueTriggers(registeredEventCue) {
                var newCue = _object_spread_props(_object_spread({}, registeredEventCue), {
                    startTime: registeredEventCue.startTime,
                    endTime: registeredEventCue.endTime
                });
                return [
                    {
                        triggerCompleted: false,
                        firedLast: false,
                        // Note: We preserve the original cue start time and end as an externally facing RegisteredEventCue to abstract away the stream time for VOD, as clients don't expect any translation
                        cue: newCue,
                        eventToFire: 'start',
                        timeToFire: newCue.startTime
                    },
                    {
                        triggerCompleted: false,
                        firedLast: false,
                        cue: newCue,
                        eventToFire: 'end',
                        timeToFire: newCue.endTime
                    }
                ];
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_eventTrack_destroy, _this_eventTrack;
                (_this_eventTrack_destroy = (_this_eventTrack = this.eventTrack).destroy) === null || _this_eventTrack_destroy === void 0 ? void 0 : _this_eventTrack_destroy.call(_this_eventTrack);
            }
        }
    ]);
    return EventManager;
}();

//# sourceMappingURL=event-manager.js.map